export const UPDATE_PROFILE_ACTIVE_PHOTO = 'UPDATE_PROFILE_ACTIVE_PHOTO';
export const UPDATE_PROFILE_CONFIRMED_STATUS = 'UPDATE_PROFILE_CONFIRMED_STATUS';

export const CONFIRMED_STATUS = 'confirmedStatus';
export const LIKES_YOU_CONFIRMED_STATUS = 'likesYouConfirmedStatus';

export const CHECK_SELFIE_VERIFICATION_NEEDED = 'CHECK_SELFIE_VERIFICATION_NEEDED';
export const SET_MATCH_SELFIE_VERIFICATION_STATUS = 'SET_MATCH_SELFIE_VERIFICATION_STATUS';
